define('views/feature_tour/Podio.Views.FeatureTourMain',['require','translate','underscore','jquery','lib/jquery/jquery.removeClassByPrefix','jquery.scrollTo','lib/backbone/Backbone.PodioView','lib/Podio.Viewport','lib/Podio.Gravity','lib/Podio.Browser','lib/Podio.Utils','jst!feature_tour/_footer','jst!feature_tour/_header','jst!feature_tour/_step','jst!onboarding_app/tour/_step1','jst!onboarding_app/tour/_step2','jst!onboarding_app/tour/_step3','jst!onboarding_app/tour/_step4','jst!calendars/tour/_step1','jst!calendars/tour/_step2','jst!calendars/tour/_step3','jst!contacts/tour/_step1','jst!contacts/tour/_step2','jst!notifications/tour/_step1','jst!notifications/tour/_step2','jst!notifications/tour/_step3','jst!tasks/tour/_step1','jst!tasks/tour/_step2','jst!tasks/tour/_step3','jst!tasks/tour/_step4','jst!tasks/tour/_step5','jst!tasks/tour/_step6','jst!tasks/tour/_step7','jst!tasks/tour/_step8','jst!tasks/tour/_step9','jst!tasks/tour/_step10','jst!spaces/tour/_step1','jst!spaces/tour/_step2','jst!spaces/tour/_step3','jst!emp_network/tour/_step1','jst!emp_network/tour/_step2','jst!emp_network/tour/_step3'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.removeClassByPrefix');
  require('jquery.scrollTo');

  var PodioView = require('lib/backbone/Backbone.PodioView');
  var PodioViewport = require('lib/Podio.Viewport');
  var PodioGravity = require('lib/Podio.Gravity');
  var podioBrowser = require('lib/Podio.Browser');
  var utils = require('lib/Podio.Utils');

  var jstFooter = require('jst!feature_tour/_footer');
  var jstHeader = require('jst!feature_tour/_header');
  var jstStep = require('jst!feature_tour/_step');
  var jstTourSteps = {
    'onboarding_app/tour/_step1': require('jst!onboarding_app/tour/_step1'),
    'onboarding_app/tour/_step2': require('jst!onboarding_app/tour/_step2'),
    'onboarding_app/tour/_step3': require('jst!onboarding_app/tour/_step3'),
    'onboarding_app/tour/_step4': require('jst!onboarding_app/tour/_step4'),
    'calendars/tour/_step1': require('jst!calendars/tour/_step1'),
    'calendars/tour/_step2': require('jst!calendars/tour/_step2'),
    'calendars/tour/_step3': require('jst!calendars/tour/_step3'),
    'contacts/tour/_step1': require('jst!contacts/tour/_step1'),
    'contacts/tour/_step2': require('jst!contacts/tour/_step2'),
    'notifications/tour/_step1': require('jst!notifications/tour/_step1'),
    'notifications/tour/_step2': require('jst!notifications/tour/_step2'),
    'notifications/tour/_step3': require('jst!notifications/tour/_step3'),
    'tasks/tour/_step1': require('jst!tasks/tour/_step1'),
    'tasks/tour/_step2': require('jst!tasks/tour/_step2'),
    'tasks/tour/_step3': require('jst!tasks/tour/_step3'),
    'tasks/tour/_step4': require('jst!tasks/tour/_step4'),
    'tasks/tour/_step5': require('jst!tasks/tour/_step5'),
    'tasks/tour/_step6': require('jst!tasks/tour/_step6'),
    'tasks/tour/_step7': require('jst!tasks/tour/_step7'),
    'tasks/tour/_step8': require('jst!tasks/tour/_step8'),
    'tasks/tour/_step9': require('jst!tasks/tour/_step9'),
    'tasks/tour/_step10': require('jst!tasks/tour/_step10'),
    'spaces/tour/_step1': require('jst!spaces/tour/_step1'),
    'spaces/tour/_step2': require('jst!spaces/tour/_step2'),
    'spaces/tour/_step3': require('jst!spaces/tour/_step3'),
    'emp_network/tour/_step1': require('jst!emp_network/tour/_step1'),
    'emp_network/tour/_step2': require('jst!emp_network/tour/_step2'),
    'emp_network/tour/_step3': require('jst!emp_network/tour/_step3')
  };

  return PodioView.extend({

    podioEvents : {
      'click .bottom .next-step'     : 'onNextStepClicked',
      'click .bottom .previous-step' : 'onPreviousStepClicked',
      'click .bottom .done'          : 'onDoneClicked',
      'click .bottom .close'         : 'onCloseClicked'
    },

    shortcuts: {
      'esc'   : 'onShortcutClosePressed',
      'left'  : 'onShortcutPreviousPressed',
      'right' : 'onShortcutNextPressed'
    },

    initialize: function( options ) {
      // Default elm since it's always the same
      this.elm = $('<div />', { 'class' : 'feature-tour'} );
      this.setElement(this.elm.get(0));

      this._super();

      _.bindAll(this, 'render', 'onWindowResize', 'onBodyHeightMonitorTick', 'onDoneClicked', 'onCloseClicked', 'fadeIn', 'fadeOut', '_initBodyHeightMonitor');

      this.elmContainer = $('#wrapper');
      this.elmWindow = $(window);
      this.elmBody = $('body');
      this.eventBridge = this.options.eventBridge;
      this.featureTourName = options.featureTourName;
      this.closeable = options.closeable;
      this.startingStep = options.startingStep;

      this.viewportHelper = new PodioViewport();
      this.gravityHelper = new PodioGravity();

      this.hasNextStep = false;
      this.hasPreviousStep = false;
      this.isShowing = false;

      this.bodyHeightMonitor = false;

      this.gravityPriorities = ['n', 'w', 'e', 's'];
      this.currentGravity = null;
      this.translations = options.translations;
    },

    gatherSteps : function() {

      var elmSteps = $( '[data-feature-tour-step^="{0}"]'.format( this.featureTourName ) );

      this.steps = _.map(elmSteps, function(domStep) {
        var elmStep = $(domStep);

        return {
          elmTarget: elmStep,
          number: elmStep.data('feature-tour-step').split(':')[1],
          title : ''
        };

      });

      this.steps = this.steps.sort(function(a, b) {
        return a.number - b.number;
      });

      _.each(this.steps, function(step, index) {
        step.logicalNumber = index + 1;
      });

      this.tourKey = elmSteps.data('feature-tour-step').split(':')[0];
    },

    startTour: function() {

      var step = this.steps[this.startingStep ? (this.startingStep - 1) : 0];

      this.showStep( step );

      setTimeout(this._initBodyHeightMonitor, 5000);
      this.elmWindow.on('resize.featureTour', this.onWindowResize);
      this.enableShortcuts();

      $('body').addClass('state-feature-tour-showing');
    },

    fadeIn: function() {
      return this.updateElementStyle( this.elmStep, { 'opacity' : 1 } );
    },

    fadeOut: function() {
      return this.updateElementStyle( this.elmStep, { 'opacity' : 0 } );
    },

    updateElementStyle: function(elmTarget, properties) {

      var dfd = new $.Deferred();

      elmTarget.one(podioBrowser.cssTransitionEndEvent, function() {
        dfd.resolve();
      });

      elmTarget.css(properties);

      return dfd;
    },

    showStep : function(step) {
      var WhenElementInViewport = new $.Deferred();
      var self = this;

      if ( !step ) {
        return;
      }

      var elmTarget = step.elmTarget;
      var attachToTarget = !elmTarget.data('feature-tour-no-target');
      var viewportInfo = this.viewportHelper.getInfo( elmTarget );

      this.trigger('featureTour:beforeShowStep', step);

      if ( attachToTarget && !viewportInfo.isInViewport ) {

        this.elmBody.scrollTo( elmTarget, 200, { axis:'y', offset: -100, onAfter: function() {
          WhenElementInViewport.resolve();
        }});

      } else {
        WhenElementInViewport.resolve();
      }

      WhenElementInViewport.then(function() {

        self.currentStep = step;
        self.previousStep = self.getPreviousStep();
        self.nextStep = self.getNextStep();
        self.isShowing = true;
        self.hasNextStep = !!self.nextStep;
        self.hasPreviousStep = !!self.previousStep;

        self.render(elmTarget);

        if (attachToTarget) {
          var elmHighlightedParent = elmTarget.parents('.feature-tour-highlighted-parent');
          if (elmHighlightedParent.length) {
            self.highlightElement(elmHighlightedParent);
          }
          else {
            self.highlightElement(elmTarget);
          }
        } else {
          self.buildUnderlay('full');
        }

        self.trigger('featureTour:afterShowStep', step);

      });

    },

    getNextStep : function() {

      var currentIndex = _.indexOf( this.steps, this.currentStep );
      var newIndex = currentIndex + 1;

      if (newIndex > this.steps.length) {
        return null;
      } else {
        return this.steps[newIndex];
      }
    },

    getPreviousStep : function() {

      var currentIndex = _.indexOf( this.steps, this.currentStep );
      var newIndex = currentIndex - 1;

      if (newIndex < 0) {
        return null;
      } else {
        return this.steps[newIndex];
      }
    },

    highlightElement: function(elmAttachmentTarget) {

      var self = this;
      var elmUnderlays = this.elm.find('.underlay');
      var isFirstTime = !elmUnderlays.length;

      elmUnderlays.remove();

      self.buildUnderlay('top', elmAttachmentTarget, isFirstTime);
      self.buildUnderlay('left', elmAttachmentTarget, isFirstTime);
      self.buildUnderlay('right', elmAttachmentTarget, isFirstTime);
      self.buildUnderlay('bottom', elmAttachmentTarget, isFirstTime);

      elmUnderlays = this.elm.find('.underlay');

      if ( isFirstTime ) {
        // Fade in
        elmUnderlays.css('opacity', 0.9);
      }
    },

    buildUnderlay : function(part, elmAttachmentTarget, hiddenByDefault) {

      var attachmentPos, attachmentWidth, attachmentHeight;

      if (elmAttachmentTarget) {
        attachmentPos = elmAttachmentTarget.offset();
        attachmentWidth = elmAttachmentTarget.outerWidth(true);
        attachmentHeight = elmAttachmentTarget.outerHeight(true);

        // Adjust position of attachment based on any desired padding
        var attachmentUnderlayPadding = this._getAttachmentUnderlayPadding(elmAttachmentTarget);
        if ( !_.isNaN(attachmentUnderlayPadding.top) ) {
          attachmentPos.top += attachmentUnderlayPadding.top;
          attachmentHeight -= attachmentUnderlayPadding.top;
        }
        if ( !_.isNaN(attachmentUnderlayPadding.right) ) {
          attachmentWidth += attachmentUnderlayPadding.right;
        }
        if ( !_.isNaN(attachmentUnderlayPadding.bottom) ) {
          attachmentHeight += attachmentUnderlayPadding.bottom;
        }
        if ( !_.isNaN(attachmentUnderlayPadding.left) ) {
          attachmentPos.left += attachmentUnderlayPadding.left;
          attachmentWidth -= attachmentUnderlayPadding.left;
        }
      }

      var viewportWidth = this.elmBody.outerWidth();
      var windowWidth = this.elmWindow.outerWidth();
      var underlayWidth = ( viewportWidth < windowWidth ) ? windowWidth : viewportWidth;

      var viewportHeight = this.elmBody.outerHeight();
      var windowHeight = this.elmWindow.outerHeight();
      var underlayHeight = ( viewportHeight < windowHeight ) ? windowHeight : viewportHeight;

      var elmUnderlay = $('<div />', { 'class' : 'underlay' });
      var cssOptions;

      if (part === 'top') {
        cssOptions = {
          'top' : 0,
          'height' : attachmentPos.top,
          'left' : 0,
          'right' : 0
        };
      }

      if (part === 'left') {
        cssOptions = {
          'top' : attachmentPos.top,
          'width' : attachmentPos.left,
          'left' : 0,
          'height' : underlayHeight - attachmentPos.top
        };
      }

      if (part === 'right') {
        cssOptions = {
          'top' : attachmentPos.top,
          'left' : attachmentPos.left + attachmentWidth,
          'right' : 0,
          'height' : underlayHeight - attachmentPos.top
        };
      }

      if (part === 'bottom') {
        cssOptions = {
          'top' : attachmentPos.top + attachmentHeight,
          'width' : attachmentWidth,
          'left' : attachmentPos.left,
          'height' : underlayHeight - attachmentHeight - attachmentPos.top
        };
      }

      if (part === 'full') {
        cssOptions = {
          'top' : 0,
          'width' : underlayWidth,
          'left' : 0,
          'height' : underlayHeight
        };
      }

      elmUnderlay.css( cssOptions );

      if ( hiddenByDefault ) {
        elmUnderlay.css('opacity', 0);
      }

      elmUnderlay.appendTo( this.elm );
    },

    renderFooter: function() {

      var footerHtml = this.getTemplate(jstFooter, {
        nextStep : this.nextStep,
        previousStep : this.previousStep,
        showClose: _.isUndefined(this.closeable) ? true : this.closeable
      });

      this.elm.find('.bottom').html( footerHtml );
    },

    renderHeader: function() {

      var headerHtml = this.getTemplate(jstHeader, {
        totalSteps : this.steps.length,
        currentStep : this.currentStep.logicalNumber,
        title : this.currentStep.title
      });

      this.elm.find('.header').html( headerHtml );
    },

    renderContent: function(data) {
      data = data || {};

      data.translations = this.translations;
      data.utils = utils;

      var templateKey = '{0}/tour/_step{1}'.format( this.tourKey, this.currentStep.number );

      var elmContent = $('<div />');
      elmContent.html( this.getTemplate(jstTourSteps[templateKey], data) );
      var elmHeader = elmContent.find('h1');

      this.currentStep.title = elmHeader.html();
      elmHeader.remove();

      this.elm.find('.content').html( elmContent );
    },

    renderGravity: function(elmAttachmentTarget) {
      var arrowOffset = 75;
      var attachmentUnderlayPadding = this._getAttachmentUnderlayPadding(elmAttachmentTarget);
      if (! _.isNaN(attachmentUnderlayPadding.left)) {
        arrowOffset += attachmentUnderlayPadding.left / 2;
      }
      if (! _.isNaN(attachmentUnderlayPadding.right)) {
        arrowOffset -= attachmentUnderlayPadding.right / 2;
      }

      var gravity;
      var attachToTarget = !elmAttachmentTarget.data('feature-tour-no-target');
      if (attachToTarget) {
        gravity = this.gravityHelper.calculateBestGravity( elmAttachmentTarget, this.elmStep );
        gravity = gravity ? gravity : 'center';
      } else {
        gravity = 'center';
      }

      return this.gravityHelper.positionStepByGravity( gravity, this.elmStep, elmAttachmentTarget, arrowOffset);
    },

    render: function(elmAttachmentTarget) {

      var self = this;

      this.elmStep = this.elm.find('.step');

      // Render basic layout
      if ( !this.elmStep.length ) {
        var html = this.getTemplate(jstStep, {
          nextStep : this.nextStep,
          previousStep : this.previousStep
        });

        this.elm.html( html );
        this.elm.addClass(this.featureTourName);

        this.elmStep = this.elm.find('.step');
        this.elmStep.css('opacity', 0);

        this.elm.appendTo( this.elmContainer );
      }

      // Set classes on step element
      this.elmStep
        .removeAttr('class')
        .addClass('step')
        .addClass('step-number-{0}'.format(this.currentStep.number))
        .addClass('step-logical-number-{0}'.format(this.currentStep.logicalNumber))
        .toggleClass('right', elmAttachmentTarget.data('arrow-alignment') === 'right')
        .toggleClass('bottom-align', elmAttachmentTarget.data('arrow-alignment') === 'bottom');

      // Rendering content
      this.renderContent();
      this.renderHeader();
      this.renderFooter();

      this.positionByGravity(elmAttachmentTarget);

      // If there is a CSS animation, position again when it's done
      this.elmStep.one(podioBrowser.cssTransitionEndEvent, function() {
        self.positionByGravity(elmAttachmentTarget);
      });
    },

    positionByGravity: function(elmAttachmentTarget) {
      this.renderGravity(elmAttachmentTarget).then(this.fadeIn);
    },

    closeTour : function() {

      var self = this;

      this.fadeOut().then(function() {
        // Clean DOM
        self.elm.remove();
      });

      // Clean memory
      this.isShowing = false;
      this.currentStep = null;
      this.previousStep = null;
      this.nextStep = null;

      // Clean event handlers
      this.disableShortcuts();
      this.elmWindow.off( 'resize.featureTour' );
      clearInterval( this.bodyHeightMonitor );

      $('body').removeClass('state-feature-tour-showing');

      this.trigger('featureTour:tourClosed');
    },

    onNextStepClicked: function(elmTarget, e) {
      this.showStep( this.nextStep );
    },

    onPreviousStepClicked: function(elmTarget, e) {
      this.showStep( this.previousStep );
    },

    onDoneClicked : function(elmTarget, e) {
      this.trigger('featureTour:tourCompleted');
    },

    onCloseClicked : function(elmTarget, e) {
      this.closeTour();
    },

    onWindowResize: function(e) {
      if ( this.isShowing && this.currentStep ) {
        this.showStep( this.currentStep );
      }
    },

    onBodyHeightMonitorTick: function() {

      var bodyHeight = $('body').outerHeight();

      if ( this.onBodyHeightMonitorTick.currentHeight !== bodyHeight ) {
        this.onBodyHeightMonitorTick.currentHeight = bodyHeight;

        if ( this.isShowing && this.currentStep ) {
          this.showStep( this.currentStep );
        }
      }
    },

    onShortcutClosePressed: function() {
      if (this.closeable) {
        this.closeTour();
      }
    },

    onShortcutNextPressed: function() {
      this.showStep( this.nextStep );
    },

    onShortcutPreviousPressed: function() {
      this.showStep( this.previousStep );
    },

    tourClosePersisted: function() {
      // Can be overridden in subviews
    },

    _getAttachmentUnderlayPadding: function(elmAttachmentTarget) {
      var attachmentUnderlayPadding = elmAttachmentTarget.data('feature-tour-padding');
      if (attachmentUnderlayPadding) {
        attachmentUnderlayPadding = attachmentUnderlayPadding.split(' ');
        attachmentUnderlayPadding = {
          top: parseInt(attachmentUnderlayPadding[0], 10),
          right: parseInt(attachmentUnderlayPadding[1], 10),
          bottom: parseInt(attachmentUnderlayPadding[2], 10),
          left: parseInt(attachmentUnderlayPadding[3], 10)
        };
      } else {
        attachmentUnderlayPadding = {
          top: NaN,
          right: NaN,
          bottom: NaN,
          left: NaN
        };
      }
      return attachmentUnderlayPadding;
    },

    _initBodyHeightMonitor: function() {
      this.onBodyHeightMonitorTick.currentHeight = $('body').outerHeight();
      this.bodyHeightMonitor = setInterval(this.onBodyHeightMonitorTick, 1000);
    }
  });

});

